export default __webpack_public_path__ + "static/media/SemiconductorMatImg.6efae38a.jpg";